import { IGlobalMessage } from "@/interfaces/IGlobalMessage";

export class State {
  message: IGlobalMessage = {};
}
